"use client";

import { Brain } from "lucide-react";
import { Shimmer } from "@/components/ai-elements/shimmer";

// Inline shimmer row affecting both icon and text using a moving mask
export const ThinkingRow = () => {
  return (
    <div className="flex items-center gap-2">
      <Brain className="h-4 w-4" />
      <Shimmer>
        Thinking
      </Shimmer>
    </div>
  );
};

